import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import { EMPTY_FILTERS } from "../constants";

const fields = [
  ["postalCodes", "portfolioExplorer.postalCode"],
  ["cities", "portfolioExplorer.city"],
  ["regions", "portfolioExplorer.region"],
  ["countries", "portfolioExplorer.country"],
];

function FiltersModal({ open, filters, options, onClose, onApply }) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(filters);

  useEffect(() => {
    if (open) setDraft(filters);
  }, [open, filters]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("portfolioExplorer.filtersTitle")}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
        {fields.map(([key, labelKey]) => (
          <Autocomplete
            key={key}
            multiple
            options={options[key]}
            value={draft[key]}
            onChange={(_, value) => setDraft((current) => ({ ...current, [key]: value }))}
            renderInput={(params) => (
              <TextField {...params} label={t(labelKey)} size="small" />
            )}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDraft(EMPTY_FILTERS)}>
          {t("portfolioExplorer.clearFilters")}
        </Button>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button variant="contained" onClick={() => onApply(draft)}>
          {t("portfolioExplorer.applyFilters")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FiltersModal;
